import { MerchantActions, MerchantAction } from '../actions/merchant.action';
import { MerchantState } from '../state/merchant.state';

export const initialMerchant: MerchantState = {
  MerchantsState: []
};

export function merchantActionReducer(state: MerchantState, action: MerchantAction) {
  switch (action.type) {
    case MerchantActions.SuccessCreateMerchant:
      return {
        ...state,
        MerchantsState: [...state.MerchantsState, action.payload]
      };
    case MerchantActions.SuccessDeleteMerchant:
      return {
        ...state,
        MerchantsState: state.MerchantsState.filter(merchant => merchant.slug !== action.payload)
      };
    case MerchantActions.SuccessUpdateMerchant:
      return {
        ...state,
        MerchantsState: state.MerchantsState.map(item => item.slug === action.payload.slug ? action.payload : item)
      };
    default:
      return state;
  }
}
